import { render, staticRenderFns } from "./HeaderAvatar.vue?vue&type=template&id=8141482c&scoped=true"
import script from "./HeaderAvatar.vue?vue&type=script&lang=js"
export * from "./HeaderAvatar.vue?vue&type=script&lang=js"
import style0 from "./HeaderAvatar.vue?vue&type=style&index=0&id=8141482c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8141482c",
  null
  
)

export default component.exports